import React from "react";

export default function QuestionReview({ q, showUser }) {
  const userAns = Array.isArray(q.user_answer) ? q.user_answer : q.user_answer ? [q.user_answer] : [];
  return (
    <div className="card-surface p-5">
      <div className="flex items-center gap-2 mb-2 text-xs text-content-muted">
        <span className="bg-ember-soft text-ember px-2 py-0.5 rounded-full">{q.subject}</span>
        <span className="capitalize">{q.difficulty}</span>
        {showUser && q.correct !== undefined && (
          <span className={q.correct ? "text-emerald-400" : userAns.length ? "text-red-400" : "text-content-muted"}>
            {q.correct ? "Correct" : userAns.length ? "Incorrect" : "Skipped"}
          </span>
        )}
      </div>
      <p className="text-sm mb-3">{q.question_text}</p>
      <div className="space-y-1.5">
        {q.options.map((o) => {
          const isCorrect = (q.correct_option_ids || []).includes(o.id);
          const isUser = userAns.includes(o.id);
          return (
            <div key={o.id} className={`text-sm px-3 py-2 rounded-lg border ${isCorrect ? "border-emerald-500/60 bg-emerald-500/10" : isUser ? "border-red-500/50 bg-red-500/10" : "border-line"}`}>
              <span className="font-mono text-xs mr-2 uppercase">{o.id}.</span>{o.text}
              {isCorrect && <span className="text-xs text-emerald-400 ml-2">✓ correct</span>}
              {isUser && !isCorrect && <span className="text-xs text-red-400 ml-2">your answer</span>}
            </div>
          );
        })}
      </div>
      {q.explanation && <div className="mt-3 text-sm text-content-secondary bg-ink rounded-lg p-3"><span className="text-ember font-medium">Explanation: </span>{q.explanation}</div>}
    </div>
  );
}
